import styled from 'styled-components';

import InputRange from 'react-input-range';

export const StyledInputRange = styled(InputRange)``;